
import { defineComponent } from 'vue'
import { runMixinEvents } from './mixin-events'

export default defineComponent({
  name: 'App',
  setup() {
    runMixinEvents()
  },
})
